/**
 * Advanced Lazy Loading for Saikospeed
 * Improves performance by delaying the loading of off-screen images
 */
document.addEventListener('DOMContentLoaded', function() {
  // Check for IntersectionObserver support
  if ('IntersectionObserver' in window) {
    const lazyImageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          const lazyImage = entry.target;
          
          // Handle background images
          if (lazyImage.dataset.bgSrc) {
            lazyImage.style.backgroundImage = `url('${lazyImage.dataset.bgSrc}')`;
            lazyImage.classList.add('lazy-loaded');
            lazyImage.removeAttribute('data-bg-src');
          }
          
          // Handle regular images with data-src
          if (lazyImage.dataset.src) {
            lazyImage.src = lazyImage.dataset.src;
            
            // If there are srcset attributes, load those too
            if (lazyImage.dataset.srcset) {
              lazyImage.srcset = lazyImage.dataset.srcset;
              lazyImage.removeAttribute('data-srcset');
            }
            
            lazyImage.classList.add('lazy-loaded');
            lazyImage.removeAttribute('data-src');
          }
          
          // Once loaded, stop observing
          observer.unobserve(lazyImage);
        }
      });
    }, {
      rootMargin: '200px 0px', // Start loading images 200px before they enter viewport
      threshold: 0.01 // Trigger when at least 1% of the item is visible
    });
    
    // Observe all elements with lazy load class
    document.querySelectorAll('.lazy-load').forEach(function(lazyImage) {
      lazyImageObserver.observe(lazyImage);
    });
    
    // Also check for new elements added to the DOM (for dynamic content)
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // ELEMENT_NODE
            if (node.classList && node.classList.contains('lazy-load')) {
              lazyImageObserver.observe(node);
            }
            
            // Also check child elements
            const lazyImages = node.querySelectorAll('.lazy-load');
            lazyImages.forEach(function(image) {
              lazyImageObserver.observe(image);
            });
          }
        });
      });
    });
    
    // Start observing the document body for changes
    observer.observe(document.body, { 
      childList: true, 
      subtree: true 
    });
  } else {
    // Fallback for browsers that don't support IntersectionObserver
    const lazyImages = document.querySelectorAll('.lazy-load');
    lazyImages.forEach(function(lazyImage) {
      if (lazyImage.dataset.src) {
        lazyImage.src = lazyImage.dataset.src;
        if (lazyImage.dataset.srcset) {
          lazyImage.srcset = lazyImage.dataset.srcset;
        }
      }
      if (lazyImage.dataset.bgSrc) {
        lazyImage.style.backgroundImage = `url('${lazyImage.dataset.bgSrc}')`;
      }
      lazyImage.classList.remove('lazy-load');
      lazyImage.classList.add('lazy-loaded');
    });
  }
});
